// @flow
import React from "react";
import { createPortal } from "react-dom";
import bowser from "data/bowser";
import Dropdown from "react-bootstrap/lib/Dropdown";
import RootCloseWrapper from "react-overlays/lib/RootCloseWrapper";
import styles from "./AbsoluteDropdown.module.css";
import { Manager, Reference, Popper } from "react-popper";
import { getClassNames } from "data/utils";

type Props = {
    /** TODO whether to open the menu on mouse hover (only on desktop)
     * @default true
     */
    openMenuOnHover?: boolean,
    /** Dropdown children */
    children: React.ElementType,
    /** button's tooltip */
    title?: string,
    /** CSS class to apply to top container */
    className?: string,
    /** whether to render toggle button as disabled */
    disabled?: boolean,
};

type State = {
    isOpen: boolean,
};

/**
 * wrapper around DropdownToggle which will absolute position the menu based on screen restrictions
 */
class AbsoluteDropdown extends React.PureComponent<Props, State> {
    // https://github.com/reactstrap/reactstrap/issues/1088
    //const [isOpen, updateIsOpen] = useState(false);
    state = { isOpen: false };

    static defaultProps = {
        openMenuOnHover: true,
    };

    _toggleIsOpen = () =>
        this.setState((prevState: State) => ({ isOpen: !prevState.isOpen }));

    _handleRootClose = () => this.setState({ isOpen: false });

    render = () => (
        <RootCloseWrapper
            disabled={false}
            onRootClose={this._handleRootClose}
            // event={rootCloseEvent}
        >
            <Manager>
                <div
                    title={this.props.title}
                    className={getClassNames(
                        "dropdown",
                        "btn-group",
                        this.props.className,
                        this.props.disabled === true ? "disabled" : ""
                    )}
                >
                    {React.Children.map(this.props.children, (child, index) => {
                        if (child.type === Dropdown.Toggle) {
                            return (
                                <Reference>
                                    {({ ref }) => (
                                        <button
                                            id={this.props.id}
                                            // {...this.props}
                                            type="button"
                                            ref={ref}
                                            onClick={this._toggleIsOpen}
                                            disabled={this.props.disabled}
                                            className={getClassNames(
                                                "dropdown-toggle",
                                                "btn",
                                                "btn-default",
                                                /* istanbul ignore next */ this
                                                    .props.bsSize === "small"
                                                    ? "btn-sm"
                                                    : "",
                                                /* istanbul ignore next */ child
                                                    .props.chrome
                                                    ? styles.chromedToggle
                                                    : "",
                                                /* istanbul ignore next */ this
                                                    .state.isOpen
                                                    ? "expanded"
                                                    : ""
                                            )}
                                        >
                                            {child.props.children}
                                            {!(
                                                child.props.noCaret === true
                                            ) && (
                                                <>
                                                    {" "}
                                                    <span className="caret" />
                                                </>
                                            )}
                                        </button>
                                    )}
                                </Reference>
                            );
                        } else if (child.type === Dropdown.Menu) {
                            if (this.state.isOpen === false) return null;
                            return createPortal(
                                <Popper
                                    modifiers={{
                                        preventOverflow: {
                                            enabled: true,
                                            boundariesElement: "window",
                                        },
                                        keepTogether: { enabled: true },
                                    }}
                                    positionFixed={false}
                                    removeOnDestroy
                                    placement="bottom-start"
                                >
                                    {({
                                        ref,
                                        style,
                                        placement,
                                        arrowProps,
                                    }) => (
                                        <ul
                                            className={`${this.props.className} dropdown-menu open`}
                                            ref={ref}
                                            style={Object.assign({}, style, {
                                                display: "block",
                                                zIndex: 1500,
                                                maxHeight: "calc(100% - 65px)",
                                                overflowY:
                                                    /* istanbul ignore next */ bowser.is(
                                                        "safari"
                                                    ) ||
                                                    /* istanbul ignore next */ bowser.is(
                                                        "iOS"
                                                    )
                                                        ? "scroll"
                                                        : "auto",
                                            })}
                                            data-placement={placement}
                                            onClick={this._handleRootClose}
                                        >
                                            {child.props.children}
                                            {/* <div
                                                ref={arrowProps.ref}
                                                style={arrowProps.style}
                                            /> */}
                                        </ul>
                                    )}
                                </Popper>,
                                document.getElementById("root")
                            );
                        } else {
                            return new Error(
                                `Unsupported child of type ${child.type.name} for AbsoluteDropdown!`
                            );
                        }
                    })}
                </div>
            </Manager>
        </RootCloseWrapper>
    );
}
export default AbsoluteDropdown;
